import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICertificaEmailState } from './certifica-email';

const feature = createFeatureSelector<ICertificaEmailState>('certificaEmail');

export const selectEsitoCertEmail = createSelector(
  feature,
  (state) => state.esito ?? ''
);

export const selectLoadingCertEmail = createSelector(
  feature,
  (state) => state.loading
);

export const selectSeedCertEmail = createSelector(
  feature,
  (state) => state.seed
);

export const selectEmailCertEmail = createSelector(
  feature,
  (state) => state.email
);

export const selectOtpError = createSelector(
  feature,
  state => state.error
);

export const selectOtpTtlSeconds = createSelector(
  feature,
  state => state.otpTtlSeconds
);

export const selectUsernameCertEmail = createSelector(
  feature,
  (state) => state.username
);

export const selectMaxTentativi = createSelector(
  feature,
  state => state.maxTentativi
);

export const selectMsgCode = createSelector(
  feature,
  state => state.msgCode
);

export const selectEmail = createSelector(
  feature,
  state => state.email
);

export const selectOtpTtlSecondsEmail = createSelector(
  feature,
  state => state.otpTtlSecondsEmail
);

export const selectCoolDownOTP = createSelector(
  feature,
  state => state.coolDownOTP
);

